export const SET_TENANT_ID = 'SET_TENANT_ID'
